import styled from 'styled-components'
import { grid, margin } from 'styled-system'
import themeGet from '@styled-system/theme-get'

import { Flex } from 'Components/UI'
import { DIV_SHOULD_FORWARD_PROP } from 'Config/shouldForwardProp'

import { LANDING_INLINE_PADDINGS } from 'Constants/Landing'

const shouldForwardProp = prop => {
  return !DIV_SHOULD_FORWARD_PROP.includes(String(prop))
}

export const Container = styled(Flex).attrs({
  pt: [48, 48, 32, 32, 32],
  pb: [48, 48, 32, 32, 32],
  px: LANDING_INLINE_PADDINGS,
})`
  width: 100%;
  justify-content: center;
  background-color: ${themeGet('colors.bg.almond')};
  position: relative;
`

export const Content = styled(Flex)`
  width: 100%;
  justify-content: center;
`

export const CropContainer = styled(Flex)
  .attrs({
    top: [0, 0, '60%'],
    width: [0, 0, 60, 60, 90, 90, 110],
    height: [0, 0, 100, 100, 150, 150, 180],
  })
  .withConfig({
    shouldForwardProp,
  })`
  right: 0;
  overflow: hidden;
  position: absolute;
`

export const DevelopmentHolder = styled.div
  .attrs({
    gridRowGap: [48, 48, 64, 64, 72],
  })
  .withConfig({
    shouldForwardProp,
  })`
  display: grid;

  ${grid}
  ${margin}
`

export const DevelopmentCard = styled(Flex)
  .withConfig({
    shouldForwardProp,
  })
  .attrs({
    flexDirection: ['column', 'column', 'row'],
  })`
  align-items: center;
  width: 100%;
`

export const DevelopmentTextHolder = styled(Flex)
  .attrs({
    width: [1, 1, 1 / 2],
  })
  .withConfig({
    shouldForwardProp,
  })`
  flex-direction: column;
  justify-content: center;
  flex-shrink: 0;
`
export const DevelopmentImageHolder = styled(Flex)
  .attrs({
    height: [270, 270, 340, 380, 480],
  })
  .withConfig({
    shouldForwardProp,
  })`
  flex-grow: 1;
  align-items: center;
  justify-content: center;
  overflow: hidden;
`

export const ProvideHolder = styled.div
  .attrs({
    gridTemplateColumns: ['1fr', '1fr', 'repeat(2, 1fr)'],
    gridRowGap: [70, 70, 0],
    gridColumnGap: [0, 0, 6],
  })
  .withConfig({
    shouldForwardProp,
  })`
  display: grid;
  position: relative;

  ${grid}
  ${margin}
`
export const ProvideCard = styled(Flex)
  .attrs({
    px: 25,
    pt: [60, 60, 75],
    pb: [24, 24, 32],
    borderRadius: [15, 15, 20],
  })
  .withConfig({
    shouldForwardProp,
  })`
  flex-direction: column;
  justify-content: space-between;
  background-color: ${themeGet('colors.bg.default')};
  position: relative;
  z-index: 1;
`
export const ProvideIconHolder = styled(Flex)
  .attrs({
    left: [24, 24, 24, 24, 32],
    height: [80, 80, 100],
    width: [80, 80, 100],
  })
  .withConfig({
    shouldForwardProp,
  })`
  position: absolute;
  top: 0;
  transform: translateY(-50%);
  align-items: center;
  justify-content: center;
  background-color: ${themeGet('colors.bg.primary')};
  border-radius: 100px;
`
export const ProvideTextHolder = styled(Flex).attrs({})`
  flex-direction: column;
`

export const ProvideSubHolder = styled(Flex)`
  align-items: center;
`

export const DotsWrapper = styled(Flex)
  .attrs({
    display: ['none', 'none', 'flex'],
    bottom: [0, 0, -15, -30, -33],
    right: [0, 0, -15, -30, -33],
  })
  .withConfig({
    shouldForwardProp,
  })`
  position: absolute;
  z-index: 0;
`

export const ButtonWrapper = styled(Flex)
  .attrs({
    justifyContent: ['flex-start', 'flex-start', 'center'],
  })
  .withConfig({
    shouldForwardProp,
  })``
